import React, { useEffect, useState } from 'react';




import OrderSuccessImg from '../../assets/Order_Success.png'
import shareImg from '../../assets/shareImg.png'
import Searching from '../../assets/Searching.gif'
import RefundedSuccess from '../../assets/RefundedSucces.png'
import { useLocation, useNavigate } from 'react-router-dom';
import RefundeInitfailed from '../../assets/refundedfailed.png'
import { Table, TableBody, TableCell, TableRow, TableHead } from '@mui/material';
import WhatsAppNumberModal from './ticket';
import TicketRaisedModal from './T';
import REFUND_UPON_REQUEST_IMG from '../../assets/REFUND_UPON_REQUEST_IMG.png'
import { format } from "date-fns";
import './style.css'
import html2canvas from 'html2canvas';
import { useRef } from 'react';
import processTick from '../../assets/processTick.png'
import step1 from '../../assets/step1.png'
import step2 from '../../assets/step2.png'
import jsPDF from "jspdf";
import logoReceipt from '../../assets/logo-receipt.png'
import refundfailed from '../../assets/refundfailed.png'
import backArrow from "../../assets/backArrow.png";
import whatsApp from "../../assets/whatsapp1.png";
import { Link } from 'react-router-dom'; 
import { CheckCircle2 } from 'lucide-react';

import {
  Box,
  Card,
  CardContent,
  Typography,
  Divider,
  Button,
  Grid,
  Stack,
  Chip,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import RefundInitiationFailedReceipt from './RefundInitiationFailedReceipt';
import OrderSuccessReceipt from './OrderSuccessReceipt';
import RefundUponRequestReceipt from './RefundUponRequestReceipt';
import RefundSuccessfulReceipt from './RefundSuccessfulReceipt';
import RefundProcessingReceipt from './RefundProcessingReceipt';
import RefundScheduledReceipt from './RefundScheduledReceipt';
import RefundFailedReceipt from './RefundFailedReceipt';
import WaitingLoder from '../../WaitingLoader/component';
import { toast } from 'react-toastify';
function InfoCard({ title, children,count,amount }) {
  return (
    <Card
      sx={{
        bgcolor: "#eef7f4",
        border: "1px solid #d9efe6",
        borderRadius: 1.5,
        boxShadow: "none",
        color:"#898C8E"
      }}
    >
      <CardContent sx={{ p: 2 }}>
        <Typography fontWeight={600} fontSize={14} mb={1} >
          {title}{" "}:<span style={{color:"black"}}>{" "}₹ {" "}{amount}</span>
        </Typography>
        <Divider sx={{ mb: 1 }} />
        {children}
      </CardContent>
    </Card>
  );
}
function OrderItemsCard({ items = [] ,props}) {
  return (
    <>
  { false?
    <div style={{ padding: "12px" }}>
      <InfoCard title="Order Items" count={items.length}>
        <Stack spacing={1.5}>
          {/* ---------- Header ---------- */}
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: "1fr 60px 70px 90px",
              alignItems: "center",
              color: "text.secondary",
              fontWeight: 600,
            }}
          >
            <Typography fontSize={12}>Item</Typography>
            <Typography fontSize={12} align="center">
              Qty
            </Typography>
            <Typography fontSize={12} align="right">
              Price
            </Typography>
            <Typography fontSize={12} align="center">
              Status
            </Typography>
          </Box>

          <Divider />

          {/* ---------- Rows ---------- */}
          {items.map((item, index) => (
            <Box
              key={index}
              sx={{
                display: "grid",
                gridTemplateColumns: "1fr 60px 70px 90px",
                alignItems: "center",
                gap: 1,
              }}
            >
              {console.log("item",item)}
              {/* Item name */}
              <Typography
                fontSize={13}
                sx={{
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
                title={item.variantName}
              >
                {item.variantName}
              </Typography>

              {/* Quantity */}
              <Typography fontSize={13} align="center">
                {item.itemQuantity}
              </Typography>

              {/* Price */}
              <Typography fontSize={13} align="right">
                ₹{item.amount}
              </Typography>

              {/* Status Chip */}
              <Chip
                size="small"
                sx={{
                  bgcolor: "#fff3e0",
                  height: 22,
                }}
                label={
                  <Box display="flex" gap={0.8} alignItems="center">
                    {item.successQuantity > 0 && (
                      <Typography fontSize={11} fontWeight={700} color="#000000B2">
                        Success ({item.successQuantity})
                      </Typography>
                    )}

                    {item.failureQuantity > 0 && (
                      <Typography fontSize={10} fontWeight={700} color="#E65C5C">
                        Failed ({item.failureQuantity})
                      </Typography>
                    )}

                    {item.vendRemaining > 0 && (
                      <Typography fontSize={10} fontWeight={700} color="#F28618">
                        Pending ({item.vendRemaining})
                      </Typography>
                    )}
                  </Box>
                }
              />
            </Box>
          ))}
        </Stack>
      </InfoCard>
          

    </div>:
      <Card  style={{boxShadow:"none"}} sx={{ mx: 2, mb: 2, background: "#EEF6F3",    border: "1px solid #d9efe6","border-radius": "6px" }}>
            <CardContent>

              <Typography variant="subtitle1" fontWeight="bold" sx={{ mb: 1 }} fontSize={12} color="#898C8E">
                Order :<span style={{ color: "#343A40" }}>{props && props.orderReport.data.orderLineItem.length}{" "} Items</span>
              </Typography>
              <Divider sx={{ my: 1 }} />
              <Stack direction="row" justifyContent="space-between">

                <Table
                  size="small"
                  sx={{
                    borderCollapse: 'separate',
                    width: '100%',
                    '& .MuiTableCell-root': {
                      borderBottom: 'none',
                      padding: '10px 0px',
                    },
                  }}
                >
                  <TableHead>
                    <TableRow>
                      <TableCell sx={{ width: '50%', fontSize: "12px", fontWeight: "500", color: "#898C8E" }}>
                        <strong>Item (Count)</strong>
                      </TableCell>
                      <TableCell sx={{ width: '25%', fontSize: "12px", fontWeight: "500", color: "#898C8E" }}>
                        <strong>Price/Unit</strong>
                      </TableCell>
                      <TableCell sx={{ width: '25%', pl: 2, fontSize: "12px", fontWeight: "500", color: "#898C8E" }}>
                        <strong>Status</strong>
                      </TableCell>
                    </TableRow>
                  </TableHead>

                  {/* Custom Divider Row */}


                  <TableBody>
                    {props && props.orderReport.data.orderLineItem.map((item, index) => (
                      <TableRow key={index}>
                        <TableCell
                        style={{paddingTop:"2px"}}
                          sx={{
                            maxWidth: 140,
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                            fontSize: "12px"
                          }}
                        >
                          {item.variantName.length > 8 ? item.variantName.slice(0, 20) + '...' : item.variantName} ({String(item.itemQuantity).padStart(2, '0')})
                        </TableCell>

                        <TableCell  style={{paddingTop:"2px"}} sx={{ fontSize: "12px" }}>
                          ₹ {item.amount}
                        </TableCell>

                        <TableCell
                        style={{paddingTop:"2px"}}
                          sx={{
                           
                            //color: item.status.includes('Refund') ? '#1976d2' : 'green',
                            fontSize: "12px",
                            whiteSpace: 'normal',  // Allow text to wrap
                            wordBreak: 'break-word', // Handle long words
                            // Adjust line height to make wrapping more natural
                            width: '50%', // Increase width for Status column to allow more space
                          }}
                        >
                          {item.successQuantity ? <span style={{ color: "#000000B2", fontSize: "12px", fontFamily: "roboto", fontWeight: "700" }}>{"Success"}({item.successQuantity})</span> : ""}{" "}{item.failureQuantity > 0 ? <span style={{ color: "#E65C5C", fontSize: "10px", fontFamily: "roboto", fontWeight: "700" }}>{"Failed"}({item.failureQuantity})</span> : ""}{" "}{item.vendRemaining ? <span style={{ color: "#F28618", fontSize: "10px", fontFamily: "roboto", fontWeight: "700" }}>{"Pending"}({item.vendRemaining})</span> : ""}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>



              </Stack>
            </CardContent>
          </Card>}

    
    </>
  );
}

function TimelineItem({ title, subtitle, time,marginTop }) {
  return (
    <Stack direction="row" spacing={2}>
    
      <Box>
        <Typography fontWeight={600}  style={{marginTop:marginTop}}>{title}</Typography>
        {subtitle && (
          <Typography variant="body2" color="text.secondary">
            {subtitle}
          </Typography>
        )}
        <Typography variant="caption" color="text.secondary">
          {time}
        </Typography>
      </Box>
    </Stack>
  );
}

/* function InfoCard({ title, children }) {
  return (
    <Card sx={{ bgcolor: "#eef7f4" }}>
      <CardContent>
        <Typography fontWeight={600} mb={1}>
          {title}
        </Typography>
        <Divider sx={{ mb: 1 }} />
        {children}
      </CardContent>
    </Card>
  );
}
 */
function InfoRow({ label, value }) {
  return (
    <Stack direction="row" justifyContent="space-between" mb={0.5}>
      <Typography variant="body2" color="text.secondary">
        {label}
      </Typography>
      <Typography variant="body2">{value}</Typography>
    </Stack>
  );
}

 function OrderStatusDesktop({transactionId,datetxt,datesuc,orderId,orderTime,platform,
  checkDevice,browser,isWebview,currentbrowser,handleShareReceiptImg,HandleRaiseTicket,
  props,mobileNumber ,items=[],formatpaymentTime,paidAmountTID,paidAmount,refundAmount,reftxdid,RefundpgName}) {
  return (
    <Box sx={{ bgcolor: "#f4f6f5", minHeight: "100vh",pb:4}}>
      
      <Box sx={{ maxWidth: 1100, mx: "auto", px: 2 }}>
        {/* Header */}
 

        <Grid container spacing={3}>
          {/* LEFT – Timeline */}
<Grid item xs={12} md={5}>
<Card style={{boxShadow:"none",background:"none",padding:0}}>
  <CardContent style={{padding:0}}>

    {/* Header */}
    <Box display="flex" justifyContent="space-between" alignItems="flex-start" p={2}>
      <Box>
        <Typography
          variant="body2"
          sx={{ color: '#583C43', fontSize: 16, fontWeight: 500 }}
        >
          Order_{orderId}
        </Typography>

        <Typography
          variant="body2"
          sx={{ color: '#583C43', fontSize: 16, fontWeight: 400 }}
        >
          {orderTime}
        </Typography>
      </Box>

      {(platform !== checkDevice || browser !== currentbrowser) &&
        isWebview !== "true" && (
          <img
            onClick={handleShareReceiptImg}
            src={shareImg}
            style={{ width: 24, cursor: "pointer" }}
          />
        )}
    </Box>

    {/* Timeline Row */}
    <Box display="flex" alignItems="flex-start" px={2}>
      
      {/* Timeline Image only */}
      <Box flexShrink={0} mr={2}>
        <img
          src={step2}
          alt="Timeline"
          style={{
            width: 34,
        /*     height: "100%", */
            objectFit: "contain"
          }}
        />
      </Box>

      {/* Timeline Content */}
      <Box flex={1}>
        <TimelineItem
          title="Refund Initiated"
          subtitle={ `Refund Reference Number : ${transactionId}`}
          time={datetxt}
         
        />

    {/*     <Divider sx={{ my: 2 }} /> */}

        <TimelineItem
          title="Refund Successful"
          time={datesuc}
           marginTop={"43px"}
          

        />
      </Box>
    </Box>

  </CardContent>
</Card>


</Grid>


          {/* RIGHT – Details */}
          <Grid item xs={12} md={7}>
            <Stack spacing={3}>
              <InfoCard title={`Refunded  Amount`} amount={paidAmount}>
          


                                                 <Stack direction="row" justifyContent="space-between" mb={0.5}>
      <Typography variant="body2" color="text.secondary">
       Date
      </Typography>
      <Typography variant="body2">{datesuc}</Typography>
    </Stack>
                                   <Stack direction="row" justifyContent="space-between" mb={0.5}>
      <Typography variant="body2" color="text.secondary">
     Transaction ID
      </Typography>
      <Typography variant="body2">{reftxdid}</Typography>
    </Stack>
                                   <Stack direction="row" justifyContent="space-between" mb={0.5}>
      <Typography variant="body2" color="text.secondary">
    Payment Method
      </Typography>
      <Typography variant="body2">  {RefundpgName}</Typography>
    </Stack>

              </InfoCard>

<OrderItemsCard items={items} props={props}/>

              <InfoCard title={`Paid Amount`} amount={paidAmount}>
              
                                 <Stack direction="row" justifyContent="space-between" mb={0.5}>
      <Typography variant="body2" color="text.secondary">
       Date
      </Typography>
      <Typography variant="body2">{formatpaymentTime}</Typography>
    </Stack>
                                   <Stack direction="row" justifyContent="space-between" mb={0.5}>
      <Typography variant="body2" color="text.secondary">
     Transaction ID
      </Typography>
      <Typography variant="body2">{paidAmountTID}</Typography>
    </Stack>
                                   <Stack direction="row" justifyContent="space-between" mb={0.5}>
      <Typography variant="body2" color="text.secondary">
    Payment Method
      </Typography>
      <Typography variant="body2">  {props && props.orderReport && props.orderReport.data.refundDetailInfoList[0].pgName}</Typography>
    </Stack>
               
            
             
              </InfoCard>

              <Card style={ {background: "#EEF6F3"}}>
                <CardContent
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                         <Box
                component="img"
                src={Searching}
                alt="Uploaded or placeholder"
                sx={{ maxWidth: '100%', maxHeight: 130, borderRadius: 2 ,}}
                style={{marginTop:"-16px",marginBottom: "-16px"}}
              />
                  <Box>
              <Typography variant="body1" color={"#000000"} fontWeight={400} fontSize={16} fontFamily={"Roboto"}>Have Any Concerns?</Typography>
              <Button
                onClick={(e) =>HandleRaiseTicket(e,props,mobileNumber)}
                variant="outlined"
                 style={{fontWeight:700,fontSize:"16px"}}
                sx={{
                  mt: 1,
                  height: "40px",
                  padding: "20px",
                  border: "2px solid #0AA36D",
                  background: "white",
                  color: "#0AA36D",
                  "&:hover": {
                    //background: "#E6F4F1", // Light green background on hover
                    //borderColor: "#0AA36D",
                  }
                }}
              >
                Raise A Ticket
              </Button>



            </Box>
                </CardContent>
              </Card>
            </Stack>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
}

const RefundStatusReceipt = ({ props, formatpaymentTime, formatrefundInitiatedTime, formatrefundCreditExpectedTime, formatrefundCreditTime, receiptRef ,totalRefundAmount,share}) => {
  //console.log("share",share)

  return (
    <div style={{ position: "absolute", zIndex: "-100" ,display:share?"":"none",width:"100%"}}>
    <div className="max-w-md mx-auto mt-10  rounded-2xl shadow-md p-4 font-sans text-sm" style={{ backgroundColor: "rgb(253 224 71)" }}  ref={receiptRef}>
      <div className="bg-white rounded-xl p-4"
       style={{marginBottom:"20vw",marginTop:"20vw"}}>
        <h2 className="text-gray-800 font-semibold text-base"> Order_{props && props.orderReport && props.orderReport.data.orderId}</h2>
        <p className="text-gray-500 text-xs mb-4">{props && props.orderReport && props.orderReport.data.refundDetailInfoList[0].paymentTime ? formatpaymentTime : "Not Availabel"}</p>


        {props && props.orderReport && props.orderReport.data.refundDetailInfoList[0].status === "REFUND_INITIATED" && 
  <RefundProcessingReceipt
  orderReport={props.orderReport}
  formatrefundInitiatedTime={formatrefundInitiatedTime}
  formatrefundCreditExpectedTime={formatrefundCreditExpectedTime}
  formatpaymentTime={formatpaymentTime}
  step1Img={step1}
/>

        }
        {props && props.orderReport && props.orderReport.data.refundDetailInfoList[0].status === "REFUND_SUCCESSFUL" && 
 <RefundSuccessfulReceipt
  orderReport={props.orderReport}
  formatrefundInitiatedTime={formatrefundInitiatedTime}
  formatrefundCreditTime={formatrefundCreditTime}
  formatpaymentTime={formatpaymentTime}
  step2Img={step2}
/>

        }
        {props && props.orderReport && props.orderReport.data.refundDetailInfoList[0].status === "REFUND_UPON_REQUEST" &&
 <RefundUponRequestReceipt
  orderReport={props.orderReport}
  formatpaymentTime={formatpaymentTime}
  refundImage={REFUND_UPON_REQUEST_IMG}
/>


        }

        {props && props.orderReport && props.orderReport.data.refundDetailInfoList[0].status === "REFUND_NOT_REQUIRED" &&
<OrderSuccessReceipt
  orderReport={props.orderReport}
  formatpaymentTime={formatpaymentTime}
  OrderSuccessImg={OrderSuccessImg}
/>

        }


        {props && props.orderReport && props.orderReport.data.refundDetailInfoList[0].status === "REFUND_INITIATION_FAILED" &&
   <RefundInitiationFailedReceipt
  orderReport={props.orderReport} 
  formatpaymentTime={formatpaymentTime} 
  failedImg={refundfailed}
/>



        }


        {props && props.orderReport && props.orderReport.data.refundDetailInfoList[0].status === "REFUND_FAILED" &&
   <RefundFailedReceipt
  orderReport={props&&props.orderReport} 
  formatpaymentTime={formatpaymentTime} 
  failedImg={RefundeInitfailed}
/>




        }

{props && props.orderReport && props.orderReport.data.refundDetailInfoList[0].status == "REFUND_SCHEDULED"&&

<RefundScheduledReceipt
  orderReport={props.orderReport}
  formatrefundCreditExpectedTime={formatrefundCreditExpectedTime}
  formatpaymentTime={formatpaymentTime}
  RefundedSuccess={RefundedSuccess}
  totalRefundAmount={totalRefundAmount}
/>



}


        <div className="mt-5 flex justify-center">
          <img src={logoReceipt} alt="Daalchini Logo" className="h-10"  />
        </div>
      </div>
    </div>
    </div>

  );
};

/* 
const HandleRaiseTicket=(e,props)=>{
  //mobileNumber
  const mobileNo =localStorage.getItem("mobileNo")
  if(mobileNo)
  {
props?.setWhatsappnum(mobileNo)
props?.handleTicket(mobileNo)

  }
  else{
  props&&props.setOpenWhatsappModal(true)
  }
} */


  const HandleRaiseTicket = (e, props,mobileNumber) => {
  // 1. First priority = query param number
  if (mobileNumber) {
    props?.setWhatsappnum(mobileNumber);
    props?.handleTicket(mobileNumber);
    return;
  }

  // 2. Second priority = localStorage number
  const localMobile = localStorage.getItem("mobileNo");

  if (localMobile) {
    props?.setWhatsappnum(localMobile);
    props?.handleTicket(localMobile);
    return;
  }

  // 3. If neither exists → open WhatsApp modal
  props?.setOpenWhatsappModal(true);
};




 export const HelpHeader = () => {
    const handleBack=()=>{
 window.location.href = "/help&support"
  }
     const location = useLocation();
     const params = new URLSearchParams(location.search);
  
  
  
    const isWebview = params.get("webview")
      const mobileNumber = params.get("mobileNumber")
    //console.log("isWebview",isWebview)
  return (
    <>
   { !(isWebview)&&<div style={styles.header}>
      <div style={{ display: "flex", alignItems: "center" }}>
        <button style={styles.iconButton}>
          <Link to="/help&support" onClick={handleBack}>
            <img src={backArrow} alt="Back" style={styles.iconImage} />
          </Link>
        </button>
        <h1 style={styles.title}> Order Status</h1>
      </div>


    </div>}
    </>
  );
};

  const styles = {
    header: {
      height: 56,
      backgroundColor: "#FFE03E",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      padding: "0 16px",
      boxSizing: "border-box",
      position:"fixed",
      width:"100%"
    },
    title: {
      flexGrow: 1,
      textAlign: "center",
      margin: 0,
      color: "#4A3F35",
      fontSize: "18px",
      fontWeight: "bold",
      marginLeft: "5vw",
    },
    iconButton: {
      background: "none",
      border: "none",
      cursor: "pointer",
      padding: 0,
    },
    iconImage: {
      width: 24,
      height: 24,
      objectFit: "contain",
    },
  };




export default function OrderSuccess(props) {

  function convertUTCtoIST(utcDateString) {
  const utcDate = new Date(utcDateString);
  // Add 5 hours and 30 minutes (IST offset)
  const istOffset = 5.5 * 60 * 60 * 1000; // milliseconds
  const istDate = new Date(utcDate.getTime() + istOffset);
  return istDate.toLocaleString('en-IN', { timeZone: 'Asia/Kolkata' });
}



  
  const navigate = useNavigate();
  const receiptRef = useRef(null);
  const [share, setShare] = useState(false);
    useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

const handleShareReceiptImg = async () => {
  if (!receiptRef.current) {
    toast.error("Receipt reference is missing!", {
      position: "top-right",
      autoClose: 5000,
    });
    return;
  }

  setShare(true);
  props?.setLoader(true);

  try {
   
    await new Promise((resolve) => {
      requestAnimationFrame(resolve);
    });

    
    const canvas = await html2canvas(receiptRef.current, {
      scale: 2,
      scrollY: 0,
      useCORS: true,
      windowWidth: receiptRef.current.scrollWidth,
      windowHeight: receiptRef.current.scrollHeight,
    });

    const imageDataUrl = canvas.toDataURL("image/png");
    const res = await fetch(imageDataUrl);
    const blob = await res.blob();
    const file = new File([blob], "receipt.png", { type: "image/png" });

    // 3️⃣ Now share (still inside user gesture!)
    if (navigator.canShare && navigator.canShare({ files: [file] })) {
      await navigator.share({
        title: "Order Receipt",
        text: "Here is your order receipt.",
        files: [file],
      });

      toast.success("Receipt shared successfully!", {
        position: "top-right",
        autoClose: 3000,
      });
    } else {
      const link = document.createElement("a");
      link.href = imageDataUrl;
      link.download = "receipt.png";
      link.click();

      toast.info("Download started (fallback)", {
        position: "top-right",
        autoClose: 3000,
      });
    }
  } catch (err) {
    //console.error("Error during sharing:", err);
    toast.error(
      `${err?.response?.data?.statusMessage || "Failed to share receipt!"}`,
      {
        position: "top-right",
        autoClose: 5000,
      }
    );
  } finally {
    setShare(false);
    props?.setLoader(false);
  }
};



  const totalRefundAmount = props && props.orderReport && props.orderReport.data.refundDetailInfoList.reduce(
    (sum, refund) => sum + (refund.refundAmount || 0),
    0
  );
  const formatpaymentTime = convertUTCtoIST(props && props.orderReport && props.orderReport.data.refundDetailInfoList[0].paymentTime)
  //console.log("formatpaymentTime",formatpaymentTime)
  const refundDate =convertUTCtoIST(props && props.orderReport && props.orderReport.data.refundDetailInfoList[0].refundInitiatedTime);
  const formattedDateTime = convertUTCtoIST(props && props.orderReport && props.orderReport.data.refundDetailInfoList[0].refundInitiatedTime)

  const formatrefundInitiatedTime = convertUTCtoIST(props && props.orderReport && props.orderReport.data.refundDetailInfoList[0].refundInitiatedTime)


  const formatrefundCreditExpectedTime = convertUTCtoIST(props && props.orderReport && props.orderReport.data.refundDetailInfoList[0].refundCreditExpectedTime)
  const formatrefundCreditTime = convertUTCtoIST(props && props.orderReport && props.orderReport.data.refundDetailInfoList[0].refundCreditTime);
  
const getBrowserInfo = () => {
  const ua = navigator.userAgent;

  let browser = "Unknown";
  if (/CriOS/.test(ua)) browser = "ChromeoniOS";
  else if (/Chrome/.test(ua)) browser = "Chrome";
  else if (/Safari/.test(ua) && !/Chrome/.test(ua)) browser = "Safari";
  else if (/Firefox/.test(ua)) browser = "Firefox";
  else if (/Edg/.test(ua)) browser = "Edge";

  let platform = "Unknown";
  if (/iPhone|iPad|iPod/.test(ua)) platform = "iOS";
  else if (/Android/.test(ua)) platform = "Android";
  else if (/Win/.test(ua)) platform = "Windows";
  else if (/Mac/.test(ua)) platform = "MacOS";
  else if (/Linux/.test(ua)) platform = "Linux";

  //console.log("User Agent:", ua);
  //console.log("Detected Browser:", browser);
  //console.log("Detected Platform:", platform);

  return { browser, platform };
};


const { browser, platform } = getBrowserInfo();
const [currentbrowser,setCurrentbrowser ] = useState("ChromeoniOS");
const [checkDevice,setCheckDevice ] = useState("iOS");
   const location = useLocation();
    const params = new URLSearchParams(location.search);
  
  
  
    const isWebview = params.get("webview")
    //console.log("isWebview",isWebview)
         const mobileNumber = params.get("mobileNumber")
  
  return (
    <>
    {props&&props.loader&&<WaitingLoder/>}
      <RefundStatusReceipt props={props} formatpaymentTime={formatpaymentTime} formatrefundInitiatedTime={formatrefundInitiatedTime} formatrefundCreditExpectedTime={formatrefundCreditExpectedTime} formatrefundCreditTime={formatrefundCreditTime} receiptRef={receiptRef} totalRefundAmount={totalRefundAmount} share={share}/>

      {props&&props.openWhatsappModal &&
       <WhatsAppNumberModal handleTicket={props && props.handleTicket} setWhatsappnum={props && props.setWhatsappnum} whatsappnum={props&&props.whatsappnum} setOpenWhatsappModal={props&&props.setOpenWhatsappModal}  />}

       {props&&props.tickeRaiseSuccesFlag&&<TicketRaisedModal  setTickeRaiseSuccesFlag={props&&props.setTickeRaiseSuccesFlag}  raiseTicketData={props&&props.raiseTicketData} orderReport={props&&props.orderReport}/>}
      <Box sx={{ bgcolor: '#f9f9f9', minHeight: '100vh',overflow: "scroll" }}>

        <HelpHeader/>
       
   {/* ------------------------------------ REFUND SUCCESS----------------------------------------------------------- */}

        {props && props.orderReport && props.orderReport.data.refundDetailInfoList[0].status == "REFUND_SUCCESSFUL" && <>

          <Box sx={{ p: 2 }}>
         
       {/*      <Box sx={{ textAlign: 'left', mb: 2,mt:8 }} display={"flex"} alignItems={"center"} justifyContent={"space-between"}>
              <div>
                <Typography variant="body2" sx={{ color: '#583C43', fontSize: "16px", fontWeight: "500" }}>
                  Order_{props && props.orderReport && props.orderReport.data.orderId}
                </Typography>
                <Typography variant="body2" sx={{ color: "#583C43", fontSize: "16px", fontWeight: "400" }}>{props && props.orderReport && props.orderReport.data.refundDetailInfoList[0].paymentTime ? formatpaymentTime : "Not Availabel"}</Typography>
              </div>
       {
  (platform==checkDevice&&browser==currentbrowser) ? null : (
    <div>
    
      {!(isWebview=="true")&&
      <img
        onClick={(e) => handleShareReceiptImg(e)}
        src={shareImg}
        style={{ width: "24px" }}
      />}
    </div>
  )
}
            </Box> */}




            <div>
              {
                <div className="max-w-md mx-auto" style={{ marginTop: "10vw" }}>
                  <div className="flex">
                   
                    {(props && props.orderReport && props.orderReport.data.refundDetailInfoList[0].status === "REFUND_INITIATED")
                      &&
                      <div>
                        <div className="flex-shrink-0 pr-4">
                          <img
                            src={step1}
                            alt="Timeline"
                            className="w-[8vw] h-[33vw]"
                          />
                        </div>

                      </div>

                    }
        {/*             {(props && props.orderReport && props.orderReport.data.refundDetailInfoList[0].status === "REFUND_SUCCESSFUL")
                      &&
                      <div>

                        <div className="flex-shrink-0 pr-4">
                          <img
                            src={step2}
                            alt="Timeline"
                            className="w-[8vw] h-[33vw]"
                          />
                        </div>
                      </div>

                    }
 */}

                    {/* Text content on the right */}
              
                  </div>
                </div>
              }

            </div>



          </Box>


{/*     <div style={{padding:"1rem",paddingBottom:0 }}>
          <div className="rounded-lg p-3 mb-4" style={{background:"#EEF6F3"}}>
            <p className="text-gray-800 font-semibold"><span style={{ color: "#898C8E",fontSize:"14px" }}>Refunded Amount : </span>₹ {props?.orderReport?.data?.refundDetailInfoList[0]?.refundAmount}</p>
            <hr style={{ marginTop: "1vw", marginBottom: "2vw" }} />
            <p className="text-xs text-gray-600 mt-1"style={{fontSize:"12px",color:"#000000B2",fontWeight:"400"}}>{formatrefundCreditTime}</p>
            <p className="text-xs text-gray-600"style={{fontSize:"12px",color:"#000000B2",fontWeight:"400"}}>Transaction ID: {props?.orderReport?.data?.refundDetailInfoList[0]?.transactionId}</p>
            <p className="text-xs text-gray-600"style={{fontSize:"12px",color:"#000000B2",fontWeight:"400"}}>Refund Account : {props?.orderReport?.data?.refundDetailInfoList[0]?.pgName}</p>
          </div>
          </div> */}
 
          
{/*        {
  (platform==checkDevice&&browser==currentbrowser) ? null : (
    <div>
      
      {!(isWebview=="true")&&
      <img
        onClick={(e) => handleShareReceiptImg(e)}
        src={shareImg}
        style={{ width: "24px" }}
      />}
    </div>
  )
} */}

<OrderStatusDesktop
 orderId={props && props.orderReport && props.orderReport.data.orderId} 
 transactionId={props?.orderReport?.data?.refundDetailInfoList[0]?.transactionId?.slice(-10)}
  datetxt={formatrefundInitiatedTime} 
  datesuc= {formatrefundCreditTime?formatrefundCreditTime:"Not Availabel"} 
orderTime={props && props.orderReport && props.orderReport.data.refundDetailInfoList[0].paymentTime ? formatpaymentTime : "Not Availabel"} 
platform={platform} checkDevice={checkDevice} browser={browser} isWebview={isWebview} currentbrowser={currentbrowser}
handleShareReceiptImg={handleShareReceiptImg}
HandleRaiseTicket={HandleRaiseTicket} props={props} mobileNumber={mobileNumber}
 items={props && props.orderReport.data.orderLineItem}
 formatpaymentTime={formatpaymentTime}
 paidAmountTID={props && props.orderReport && props.orderReport.data.refundDetailInfoList[0].transactionId}
pgName={props && props.orderReport && props.orderReport.data.refundDetailInfoList[0].pgName}
paidAmount={props && props.orderReport && props.orderReport.data.refundDetailInfoList[0].paidAmount}
refundAmount={props?.orderReport?.data?.refundDetailInfoList[0]?.refundAmount}
 reftxdid={props?.orderReport?.data?.refundDetailInfoList[0]?.transactionId}
 RefundpgName={props?.orderReport?.data?.refundDetailInfoList[0]?.pgName}
/>
         



    

        </>
        }
      {/* ------------------------------ REFUND SUCCESS------END---------------------------- */}


{/* -----------------------------------------REFUND_SCHEDULED-------------------------------------------------------------------- */}

        {props && props.orderReport && props.orderReport.data.refundDetailInfoList[0].status == "REFUND_SCHEDULED" && <>

          <Box sx={{ p: 2 }}>
            <Box sx={{ textAlign: 'left', mb: 2,mt:8 }} display={"flex"} alignItems={"center"} justifyContent={"space-between"}>
              <div>
                <Typography variant="body2" sx={{ color: '#583C43', fontSize: "16px", fontWeight: "500" }}>
                  Order_{props && props.orderReport && props.orderReport.data.orderId}
                </Typography>
                <Typography variant="body2" sx={{ color: "#583C43", fontSize: "16px", fontWeight: "400" }}>{props && props.orderReport && props.orderReport.data.refundDetailInfoList[0].paymentTime ? formatpaymentTime : "Not Availabel"}</Typography>
              </div>
             
        {
  (platform==checkDevice&&browser==currentbrowser) ? null : (
    <div>
{/*       {console.log("isWebview condition for share btn",isWebview,!(isWebview=="true"))} */}
      {!(isWebview=="true")&&<img
        onClick={(e) => handleShareReceiptImg(e)}
        src={shareImg}
        style={{ width: "24px" }}
      />}
    </div>
  )
}
            </Box>




            <div>
              <Box sx={{ display: "flex", justifyContent: "center" }}>
                <Box
                  component="img"
                  src={RefundedSuccess}
                  alt="Order Success"
                  sx={{ maxHeight: 155, borderRadius: 2, width: "68px", height: "60px" ,mt:5}}
                />
              </Box>

              <h1
                style={{
                  color: "#01869E",
                  fontSize: "20px",
                  fontWeight: "600",
                  textAlign: "center",
                  marginTop: "2vw",
                }}
              >
                Refund Scheduled
              </h1>

              <div className="refund-box">
                <p>
                  You will receive your refund with in 40 minutes
             </p>
              </div>
            </div>



          </Box>


          <Card  style={{boxShadow:"none"}} sx={{ mx: 2, mb: 2, background: "#EEF6F3" }}>
            <CardContent>
              <Typography variant="subtitle1" fontWeight="bold" fontSize={12} color="#898C8E">
                Amount To Be Refunded :  <span style={{ color: "#343A40" }}> ₹{totalRefundAmount}</span>
              </Typography>
              <Divider sx={{ my: 1 }} />

              <Typography variant="body2" sx={{ wordBreak: 'break-word', fontWeight: "400", fontSize: "10px" }}>
                Amount will be refunded to source/ wallet/UPI/Card/Bank/Daalchini Wallet
              </Typography>
            </CardContent>
          </Card>

          <Card style={{boxShadow:"none"}} sx={{ mx: 2, mb: 2, background: "#EEF6F3" }}>
            <CardContent>

              <Typography variant="subtitle1" fontWeight="bold" sx={{ mb: 1 }} fontSize={12} color="#898C8E">
                Order :<span style={{ color: "#343A40" }}>{props && props.orderReport.data.orderLineItem.length}{" "} Items</span>
              </Typography>
              <Divider sx={{ my: 1 }} />
              <Stack direction="row" justifyContent="space-between">

                <Table
                  size="small"
                  sx={{
                    borderCollapse: 'separate',
                    width: '100%',
                    '& .MuiTableCell-root': {
                      borderBottom: 'none',
                      padding: '10px 0px',
                    },
                  }}
                >
                  <TableHead>
                    <TableRow>
                      <TableCell style={{ paddingTop:"2vw"}} sx={{ width: '50%', fontSize: "12px", fontWeight: "500", color: "#898C8E" }}>
                        <strong>Item (Count)</strong>
                      </TableCell>
                      <TableCell style={{ paddingTop:"2vw"}} sx={{ width: '25%', fontSize: "12px", fontWeight: "500", color: "#898C8E" }}>
                        <strong>Price/Unit</strong>
                      </TableCell>
                      <TableCell  style={{ paddingTop:"2vw"}} sx={{ width: '25%', pl: 2, fontSize: "12px", fontWeight: "500", color: "#898C8E" }}>
                        <strong>Status</strong>
                      </TableCell>
                    </TableRow>
                  </TableHead>

                  {/* Custom Divider Row */}


                  <TableBody>
                    {props && props.orderReport.data.orderLineItem.map((item, index) => (
                      <TableRow key={index}>
                        <TableCell
                        style={{ paddingTop:"2vw",fontSize:"12px"}}
                          sx={{
                            maxWidth: 140,
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                            fontSize: "12px"
                          }}
                        >
                          {item.variantName.length > 8 ? item.variantName.slice(0, 20) + '...' : item.variantName} ({String(item.itemQuantity).padStart(2, '0')})
                        </TableCell>

                        <TableCell  style={{ paddingTop:"2vw"}} sx={{ fontSize: "12px" }}>
                          ₹ {item.amount}
                        </TableCell>

                        <TableCell
                        style={{ paddingTop:"2vw",fontSize:"12px"}}
                          sx={{
                           
                            //color: item.status.includes('Refund') ? '#1976d2' : 'green',
                            fontSize: "10px",
                            whiteSpace: 'normal',  // Allow text to wrap
                            wordBreak: 'break-word', // Handle long words
                            // Adjust line height to make wrapping more natural
                            width: '50%', // Increase width for Status column to allow more space
                          }}
                        >
                          {item.successQuantity ? <span style={{ color: "#000000B2", fontSize: "10px", fontFamily: "roboto", fontWeight: "700" }}>{"Success"}({item.successQuantity})</span> : ""}{" "}{item.failureQuantity > 0 ? <span style={{ color: "#E65C5C", fontSize: "10px", fontFamily: "roboto", fontWeight: "700" }}>{"Failed"}({item.failureQuantity})</span> : ""}{" "}{item.vendRemaining ? <span style={{ color: "#F28618", fontSize: "10px", fontFamily: "roboto", fontWeight: "700" }}>{"Pending"}({item.vendRemaining})</span> : ""}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>



              </Stack>
            </CardContent>
          </Card>
          <Card style={{boxShadow:"none"}} sx={{ mx: 2, mb: 2, background: "#EEF6F3" }}>
            <CardContent>
              <Typography variant="subtitle1" fontWeight="bold" fontSize={12} color="#898C8E">
              
                Paid Amount :<span style={{ color: "#343A40" }}> ₹{props && props.orderReport && props.orderReport.data.refundDetailInfoList[0].paidAmount}</span>
              </Typography>


              <Divider sx={{ my: 1 }} />
              <Typography variant="body2" style={{fontSize:"12px"}}>{formatpaymentTime}</Typography>
              <Typography variant="body2" sx={{ wordBreak: 'break-word' }}>
               <span style={{fontSize:"12px",color:"#000000B2",fontWeight:"400"}}> Transaction ID: {props && props.orderReport && props.orderReport.data.refundDetailInfoList[0].transactionId}</span>
              </Typography>
              <Typography variant="body2" sx={{ wordBreak: 'break-word' }}>
                <span style={{fontSize:"12px",color:"#000000B2",fontWeight:"400"}}>Payment Method :  {props && props.orderReport && props.orderReport.data.refundDetailInfoList[0].pgName}</span>
              </Typography>
            </CardContent>
          </Card>


          <Card  sx={{ display: "flex", justifyContent: "space-around", alignItems: "center", mx: 2, mb: 2, textAlign: 'center', background: "#EEF6F3", }} style={{ marginBottom:isWebview? "150px":"100px" ,boxShadow:"none",marginTop:"5vw"}}>

            {/* Illustration Placeholder */}
            <Box sx={{  }}>
              <Box
                component="img"
                src={Searching}
                alt="Uploaded or placeholder"
                sx={{ maxWidth: '100%', maxHeight: 130, borderRadius: 2 }}
              />
            </Box>
            <Box>
              <Typography variant="body1" color={"#000000"} fontWeight={400} fontSize={16} fontFamily={"Roboto"}>Have Any Concerns?</Typography>
              <Button
                onClick={(e) => HandleRaiseTicket(e,props,mobileNumber)}
                style={{fontWeight:700,borderRadius:"8px"}}
                variant="outlined"
                sx={{
                  mt: 1,
                  height: "40px",
                  padding: "20px",
                  border: "2px solid #0AA36D",
                  background: "white",
                  color: "#0AA36D",
                   textTransform: 'none',
                  "&:hover": {
                    //background: "#E6F4F1", // Light green background on hover
                    //borderColor: "#0AA36D",

                  }
                }}
              >
                Raise A Ticket
              </Button>



            </Box>
          </Card>
        </>
        }
{/* ------------------REFUND_SCHEDULED--------------END---------------- */}


{/* ----------------------------------------------"REFUND_UPON_REQUEST ------------------------------------------------------------- */}
        {props && props.orderReport && props.orderReport.data.refundDetailInfoList[0].status == "REFUND_UPON_REQUEST" && <>

          <Box sx={{ p: 2 }}>
            <Box sx={{ textAlign: 'left', mb: 2,mt:8 }} display={"flex"} alignItems={"center"} justifyContent={"space-between"}>
              <div>
                <Typography variant="body2" sx={{ color: '#583C43', fontSize: "16px", fontWeight: "500" }}>
                  Order_{props && props.orderReport && props.orderReport.data.orderId}
                </Typography>
                <Typography variant="body2" sx={{ color: "#583C43", fontSize: "16px", fontWeight: "400" }}>{props && props.orderReport && props.orderReport.data.refundDetailInfoList[0].paymentTime ? formatpaymentTime : "Not Availabel"}</Typography>
              </div>
       {
  (platform==checkDevice&&browser==currentbrowser) ? null : (
    <div>
       {/*  {console.log("isWebview condition for share btn",isWebview,!(isWebview=="true"))} */}
      {!(isWebview=="true")&&
      <img
        onClick={(e) => handleShareReceiptImg(e)}
        src={shareImg}
        style={{ width: "24px" }}
      />
}
    </div>
  )
}
            </Box>




            <div>
              <Box sx={{ display: "flex", justifyContent: "center" }}>
                <Box
                  component="img"
                  src={REFUND_UPON_REQUEST_IMG}
                  alt="Order Success"
                  sx={{ maxHeight: 155, borderRadius: 2, width: "68px", height: "68px",mt:5 }}
                />
              </Box>


              <h1
                style={{
                  color: "#F28618",
                  fontSize: "20px",
                  fontWeight: "600",
                  textAlign: "center",
                  marginTop: "2vw",
                }}
              >
                Received your order?
              </h1>
              <div className="refund-box">
                <p style={{fontSize:"12px"}}>
                 Looks like There May Be A Problem With Your Order
                </p>
              </div>
            </div>



          </Box>


      

          <Card  style={{boxShadow:"none"}} sx={{ mx: 2, mb: 2, background: "#EEF6F3" }}>
            <CardContent>

              <Typography variant="subtitle1" fontWeight="bold" sx={{ mb: 1 }} fontSize={12} color="#898C8E">
                Order :<span style={{ color: "#343A40" }}>{props && props.orderReport.data.orderLineItem.length}{" "} Items</span>
              </Typography>
              <Divider sx={{ my: 1 }} />
              <Stack direction="row" justifyContent="space-between">

                <Table
                  size="small"
                  sx={{
                    borderCollapse: 'separate',
                    width: '100%',
                    '& .MuiTableCell-root': {
                      borderBottom: 'none',
                      padding: '10px 0px',
                    },
                  }}
                >
                  <TableHead>
                    <TableRow>
                      <TableCell sx={{ width: '50%', fontSize: "12px", fontWeight: "500", color: "#898C8E" }}>
                        <strong>Item (Count)</strong>
                      </TableCell>
                      <TableCell sx={{ width: '25%', fontSize: "12px", fontWeight: "500", color: "#898C8E" }}>
                        <strong>Price/Unit</strong>
                      </TableCell>
                      <TableCell sx={{ width: '25%', pl: 2, fontSize: "12px", fontWeight: "500", color: "#898C8E" }}>
                        <strong>Status</strong>
                      </TableCell>
                    </TableRow>
                  </TableHead>

                  {/* Custom Divider Row */}


                  <TableBody>
                    {props && props.orderReport.data.orderLineItem.map((item, index) => (
                      <TableRow key={index}>
                        <TableCell
                         style={{paddingTop:"2vw"}}
                          sx={{
                            maxWidth: 140,
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                            fontSize: "12px"
                          }}
                        >
                          {item.variantName.length > 8 ? item.variantName.slice(0, 20) + '...' : item.variantName} ({String(item.itemQuantity).padStart(2, '0')})
                        </TableCell>

                        <TableCell style={{paddingTop:"2vw"}} sx={{ fontSize: "12px" }}>
                          ₹ {item.amount}
                        </TableCell>

                        <TableCell
                        style={{paddingTop:"2vw"}}
                          sx={{
                            pl: 2,
                            //color: item.status.includes('Refund') ? '#1976d2' : 'green',
                            fontSize: "12px",
                            whiteSpace: 'normal',  // Allow text to wrap
                            wordBreak: 'break-word', // Handle long words
                            // Adjust line height to make wrapping more natural
                            width: '50%', // Increase width for Status column to allow more space
                          }}
                        >
                          {item.successQuantity ? <span style={{ color: "#000000B2", fontSize: "12px", fontFamily: "roboto", fontWeight: "700" }}>{"Success"}({item.successQuantity})</span> : ""}{" "}{item.failureQuantity > 0 ? <span style={{ color: "#E65C5C", fontSize: "12px", fontFamily: "roboto", fontWeight: "700" }}>{"Failed"}({item.failureQuantity})</span> : ""}{" "}{item.vendRemaining ? <span style={{ color: "#F28618", fontSize: "12px", fontFamily: "roboto", fontWeight: "700" }}>{"Pending"}({item.vendRemaining})</span> : ""}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>



              </Stack>
            </CardContent>
          </Card>
          <Card style={{boxShadow:"none"}} sx={{ mx: 2, mb: 2, background: "#EEF6F3" }}>
            <CardContent>
              <Typography variant="subtitle1" fontWeight="bold" fontSize={12} color="#898C8E">
                Paid Amount :<span style={{ color: "#343A40" }}> ₹{props && props.orderReport && props.orderReport.data.refundDetailInfoList[0].paidAmount}</span>
              </Typography>


              <Divider sx={{ my: 1 }} />
              <Typography variant="body2" style={{fontSize:"12px",color:"#000000B2"}}>{formatpaymentTime}</Typography>
              <Typography variant="body2" sx={{ wordBreak: 'break-word' }}>
                <span style={{fontSize:"10px",color:"#000000B2",fontWeight:"400"}}>Transaction ID: {props && props.orderReport && props.orderReport.data.refundDetailInfoList[0].transactionId}</span>
              </Typography>
              <Typography variant="body2" sx={{ wordBreak: 'break-word' }}>
               <span style={{fontSize:"10px",color:"#000000B2",fontWeight:"400"}}> Payment Method :  {props && props.orderReport && props.orderReport.data.refundDetailInfoList[0].pgName}</span>
              </Typography>
            </CardContent>
          </Card>


          <Card style={{boxShadow:"none",marginTop:"5vw"}} sx={{ display: "flex", justifyContent: "space-around", alignItems: "center", mx: 2, mb: 2, textAlign: 'center', background: "#EEF6F3", }}>

            {/* Illustration Placeholder */}
            <Box sx={{ }}>
              <Box
                component="img"
                src={Searching}
                alt="Uploaded or placeholder"
                sx={{ maxWidth: '100%', maxHeight: 130, borderRadius: 2 }}
              />
            </Box>
            <Box>
              <Typography variant="body1" color={"#000000"} fontWeight={400} fontSize={16} fontFamily={"Roboto"}>Please raise ticket here</Typography>
              <Button
                onClick={(e) =>HandleRaiseTicket(e,props,mobileNumber)}
                variant="outlined"
                 style={{fontWeight:700,fontSize:"16px"}}
                sx={{
                  mt: 1,
                  height: "40px",
                  padding: "20px",
                  border: "2px solid #0AA36D",
                  background: "#0AA36D",
                  color: "white",
                    textTransform: 'none',
                  "&:hover": {
                    //background: "#E6F4F1", // Light green background on hover
                    //borderColor: "#0AA36D",
                  }
                }}
              >
                Raise A Ticket
              </Button>



            </Box>
          </Card>
        </>
        }

        {/* -----------"REFUND_UPON_REQUEST------END -----------*/}


{/* -----------------------------------------"REFUND_NOT_REQUIRED------------------------------------------------------------------------- */}

        {props && props.orderReport && props.orderReport.data.refundDetailInfoList[0].status == "REFUND_NOT_REQUIRED" && <>

          <Box sx={{ p: 2 }}>
            {/* Top: Left-Aligned Text */}
            <Box sx={{ textAlign: 'left', mb: 2 ,mt:8}} display={"flex"} alignItems={"center"} justifyContent={"space-between"}>
              <div>
                <Typography variant="body2" sx={{ color: '#583C43', fontSize: "16px", fontWeight: "500" }}>
                  Order_{props && props.orderReport && props.orderReport.data.orderId}
                </Typography>
                <Typography variant="body2" sx={{ color: "#583C43", fontSize: "16px", fontWeight: "400" }}>{props && props.orderReport && props.orderReport.data.refundDetailInfoList[0].paymentTime ? formatpaymentTime : "Not Availabel"}</Typography>
              </div>
       {
  (platform==checkDevice&&browser==currentbrowser) ? null : (
    <div>
      {/*   {console.log("isWebview condition for share btn",isWebview,!(isWebview=="true"))} */}
      {!(isWebview=="true")&&
      <img
        onClick={(e) => handleShareReceiptImg(e)}
        src={shareImg}
        style={{ width: "24px" }}
      />}
    </div>
  )
}
            </Box>



            <div>
              <Box sx={{ display: "flex", justifyContent: "center" }}>
                <Box
                  component="img"
                  src={OrderSuccessImg}
                  alt="Order Success"
                  sx={{ maxHeight: 155, borderRadius: 2, width: "160px", height: "160px" }}
                />
              </Box>



         
            </div>



          </Box>


     

          <Card style={{boxShadow:"none"}} sx={{ mx: 2, mb: 2, background: "#EEF6F3" ,boxShadow:"none"}}>
            <CardContent>

              <Typography variant="subtitle1" fontWeight="bold" sx={{ mb: 1 }} fontSize={14} color="#898C8E">
                Order :<span style={{ color: "#343A40" }}>{props && props.orderReport.data.orderLineItem.length}{" "} Items</span>
              </Typography>
              <Divider sx={{ my: 1 }} />
              <Stack direction="row" justifyContent="space-between">

                <Table
                  size="small"
                  sx={{
                    borderCollapse: 'separate',
                    width: '100%',
                    '& .MuiTableCell-root': {
                      borderBottom: 'none',
                      padding: '10px 0px',
                    },
                  }}
                >
                  <TableHead>
                    <TableRow>
                      <TableCell sx={{ width: '50%', fontSize: "12px", fontWeight: "500", color: "#898C8E" }}>
                        <strong>Item (Count)</strong>
                      </TableCell>
                      <TableCell sx={{ width: '25%', fontSize: "12px", fontWeight: "500", color: "#898C8E" }}>
                        <strong>Price/Unit</strong>
                      </TableCell>
                      <TableCell sx={{ width: '25%', pl: 2, fontSize: "12px", fontWeight: "500", color: "#898C8E" }}>
                        <strong>Status</strong>
                      </TableCell>
                    </TableRow>
                  </TableHead>

                  {/* Custom Divider Row */}


                  <TableBody>
                    {props && props.orderReport.data.orderLineItem.map((item, index) => (
                      <TableRow key={index}>
                        <TableCell
                        style={{paddingTop:"2px"}}
                          sx={{
                            maxWidth: 140,
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                            fontSize: "12px"
                          }}
                        >
                          {item.variantName.length > 8 ? item.variantName.slice(0, 20) + '...' : item.variantName} ({String(item.itemQuantity).padStart(2, '0')})
                        </TableCell>

                        <TableCell sx={{ fontSize: "12px" }}  style={{paddingTop:"2px"}}>
                          ₹ {item.amount}
                        </TableCell>

                        <TableCell
                         style={{paddingTop:"2px",fontSize:"12px"}}
                          sx={{
                            pl: 2,
                            //color: item.status.includes('Refund') ? '#1976d2' : 'green',
                            fontSize: "12px",
                            whiteSpace: 'normal',  // Allow text to wrap
                            wordBreak: 'break-word', // Handle long words
                            // Adjust line height to make wrapping more natural
                            width: '50%', // Increase width for Status column to allow more space
                          }}
                        >
                          {item.successQuantity ? <span style={{ color: "#000000B2", fontSize: "12px", fontFamily: "roboto", fontWeight: "700" }}>{"Success"}({item.successQuantity})</span> : ""}{" "}{item.failureQuantity > 0 ? <span style={{ color: "#E65C5C", fontSize: "12px", fontFamily: "roboto", fontWeight: "700" }}>{"Failed"}({item.failureQuantity})</span> : ""}{" "}{item.vendRemaining ? <span style={{ color: "#F28618", fontSize: "12px", fontFamily: "roboto", fontWeight: "700" }}>{"Pending"}({item.vendRemaining})</span> : ""}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>



              </Stack>
            </CardContent>
          </Card>
          <Card style={{boxShadow:"none"}} sx={{ mx: 2, mb: 2, background: "#EEF6F3" }} >
            <CardContent>
              <Typography variant="subtitle1" fontWeight="bold" fontSize={14} color="#898C8E">

                Paid Amount :<span style={{ color: "#343A40" }}> ₹{props && props.orderReport && props.orderReport.data.refundDetailInfoList[0].paidAmount}</span>
              </Typography>


              <Divider sx={{ my: 1 }} />
              <Typography variant="body2" style={{fontSize:"12px",color:"#000000B2"}}>{formatpaymentTime}</Typography>
              <Typography variant="body2" sx={{ wordBreak: 'break-word' }}>
                <span style={{fontSize:"12px",color:"#000000B2",fontWeight:"400"}}>Transaction ID: {props && props.orderReport && props.orderReport.data.refundDetailInfoList[0].transactionId}</span>
              </Typography>
              <Typography variant="body2" sx={{ wordBreak: 'break-word' }}>
                <span style={{fontSize:"12px",color:"#000000B2",fontWeight:"400"}}>Payment Method :  {props && props.orderReport && props.orderReport.data.refundDetailInfoList[0].pgName}</span>
              </Typography>
            </CardContent>
          </Card>


          <Card style={{boxShadow:"none",marginBottom:isWebview?"150px":"110px"}} sx={{ display: "flex", justifyContent: "space-around", alignItems: "center", mx: 2, mb: 2, textAlign: 'center',  background: "#EEF6F3", }}>

            {/* Illustration Placeholder */}
            <Box sx={{  }}>
              <Box
                component="img"
                src={Searching}
                alt="Uploaded or placeholder"
                sx={{ maxWidth: '100%', maxHeight: 111, borderRadius: 2 }}
              />
            </Box>
            <Box>
              <Typography variant="body1" color={"#000000"} fontWeight={400} fontSize={16} fontFamily={"Roboto"}>Have Any Concerns?</Typography>
              <Button
                onClick={(e) => HandleRaiseTicket(e,props,mobileNumber)}
                variant="outlined"
                 style={{fontWeight:700,fontSize:"16px"}}
                sx={{
                  mt: 1,
                  height: "40px",
                  padding: "20px",
                  border: "2px solid #0AA36D",
                  background: "white",
                  color: "#0AA36D",
                    textTransform: 'none',
                  "&:hover": {
                    //background: "#E6F4F1", // Light green background on hover
                    //borderColor: "#0AA36D",
                  }
                }}
              >
                Raise A Ticket
              </Button>



            </Box>
          </Card>
        </>
        }


        {/* ----------------------"REFUND_NOT_REQUIRED----------------END */}


        {props && props.orderReport && props.orderReport.data.refundDetailInfoList[0].status == "REFUND_INITIATED" && <>

          <Box sx={{ p: 2 }}>
            {/* Top: Left-Aligned Text */}
            <Box sx={{ textAlign: 'left', mb: 2 ,mt:8}} display={"flex"} alignItems={"center"} justifyContent={"space-between"}>
              <div>
                <Typography variant="body2" sx={{ color: '#583C43', fontSize: "16px", fontWeight: "500" }}>
                  Order_{props && props.orderReport && props.orderReport.data.orderId}
                </Typography>
                <Typography variant="body2" sx={{ color: "#583C43", fontSize: "16px", fontWeight: "400" }}>{props && props.orderReport && props.orderReport.data.refundDetailInfoList[0].paymentTime ? formatpaymentTime : "Not Availabel"}</Typography>
              </div>
       {
  (platform==checkDevice&&browser==currentbrowser) ? null : (
    <div>
        {/* {console.log("isWebview condition for share btn",isWebview,!(isWebview=="true"))} */}
      {!(isWebview=="true")&&
      <img
        onClick={(e) => handleShareReceiptImg(e)}
        src={shareImg}
        style={{ width: "24px" }}
      />}
    </div>
  )
}
            </Box>




            <div>
              {
                <div className="max-w-md mx-auto" style={{ marginTop: "10vw" }}>
                  <div className="flex">
                    {/* Timeline image on the left */}
                    {(props && props.orderReport && props.orderReport.data.refundDetailInfoList[0].status === "REFUND_INITIATED")
                      &&
                      <div>
                        <div className="flex-shrink-0 pr-4">
                          <img
                            src={step1}
                            alt="Timeline"
                            className="w-[8vw] h-[33vw]"
                          />
                        </div>

                      </div>

                    }
                    {(props && props.orderReport && props.orderReport.data.refundDetailInfoList[0].status === "REFUND_SUCCESSFUL")
                      &&
                      <div>
                        <div className="flex-shrink-0 pr-4">
                          <img
                            src={step1}
                            alt="Timeline"
                            className="w-[8vw] h-[33vw]"
                          />
                        </div>
                        <div className="flex-shrink-0 pr-4">
                          <img
                            src={step2}
                            alt="Timeline"
                            className="w-[8vw] h-[33vw]"
                          />
                        </div>
                      </div>

                    }


                    {/* Text content on the right */}
                    <div className="space-y-6">
                      {/* Refund Initiated */}
                      <div>
                        <h3 className="text-base font-semibold text-gray-800">Refund Initiated</h3>
                        <p className="text-sm text-gray-700">
                          Refund Reference Number:{" "}
                          <span className="font-medium">
                            {props?.orderReport?.data?.refundDetailInfoList[0]?.transactionId?.slice(-10)}
                          </span>
                          ,
                        </p>
                        <p className="text-sm text-gray-700">{formatpaymentTime}</p>
                      </div>

                      {/* Refund Processing By Bank */}
                      <div>
                        <h3 className="text-base font-semibold text-gray-800">Refund Processing By Bank</h3>
                        <p className="text-sm text-gray-700">
                          Expected Settlement By {formatrefundCreditExpectedTime}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              }

            </div>



          </Box>

<div style={{padding:"10px"}}>
           <div className="rounded-lg p-3 mb-4" style={{background:"#EEF6F3"}}>
            <p className="text-gray-500 font-semibold"><span style={{ color: "#898C8E", fontWeight:"500",fontSize:"14px"}}>Amount To Be Refunded :</span>{" "}₹ {props?.orderReport?.data?.refundDetailInfoList[0]?.refundAmount}</p>
            <hr style={{ marginTop: "1vw", marginBottom: "2vw" }} />
           
            <p className="text-xs text-gray-600"style={{fontSize:"12px",color:"##000000B2",fontWeight:"400"}}>Amount will be refunded to source/ wallet/UPI/Card/Bank/Daalchini Wallet</p>
            
          </div>
          </div>


          <Card style={{boxShadow:"none"}}  sx={{ mx: 2, mb: 2, background: "#EEF6F3" }}>
            <CardContent>

              <Typography variant="subtitle1" fontWeight="bold" sx={{ mb: 1 }} fontSize={14} color="#898C8E">
                Order :<span style={{ color: "#343A40" }}>{props && props.orderReport.data.orderLineItem.length}{" "} Items</span>
              </Typography>
              <Divider sx={{ my: 1 }} />
              <Stack direction="row" justifyContent="space-between">

                <Table
                s
                  size="medium"
                  sx={{
                    borderCollapse: 'separate',
                    width: '100%',
                    '& .MuiTableCell-root': {
                      borderBottom: 'none',
                      padding: '10px 0px',
                    },
                  }}
                >
                  <TableHead>
                    <TableRow>
                      <TableCell sx={{ width: '50%', fontSize: "12px", fontWeight: "500", color: "#898C8E" }}>
                        <strong>Item (Count)</strong>
                      </TableCell>
                      <TableCell sx={{ width: '25%', fontSize: "12px", fontWeight: "500", color: "#898C8E" }}>
                        <strong>Price/Unit</strong>
                      </TableCell>
                      <TableCell sx={{ width: '25%', pl: 2, fontSize: "12px", fontWeight: "500", color: "#898C8E" }}>
                        <strong>Status</strong>
                      </TableCell>
                    </TableRow>
                  </TableHead>

                  {/* Custom Divider Row */}


                  <TableBody>
                    {props && props.orderReport.data.orderLineItem.map((item, index) => (
                      <TableRow key={index}>
                        <TableCell
                        style={{paddingTop:"2px"}}
                          sx={{
                            maxWidth: 140,
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                            fontSize: "12px",
                            
                          }}
                        >
                          {item.variantName.length > 8 ? item.variantName.slice(0, 20) + '...' : item.variantName} ({String(item.itemQuantity).padStart(2, '0')})
                        </TableCell>

                        <TableCell style={{paddingTop:"2px"}} sx={{ fontSize: "12px" }}>
                          ₹ {item.amount}
                        </TableCell>

                        <TableCell
                        style={{paddingTop:"2px"}}
                          sx={{
                            
                            //color: item.status.includes('Refund') ? '#1976d2' : 'green',
                            fontSize: "12px",
                            whiteSpace: 'normal',  // Allow text to wrap
                            wordBreak: 'break-word', // Handle long words
                            // Adjust line height to make wrapping more natural
                            width: '50%', // Increase width for Status column to allow more space
                          }}
                        >
                          {item.successQuantity ? <span style={{ color: "#000000B2", fontSize: "12px", fontFamily: "roboto", fontWeight: "700" }}>{"Success"}({item.successQuantity})</span> : ""}{" "}{item.failureQuantity > 0 ? <span style={{ color: "#E65C5C", fontSize: "10px", fontFamily: "roboto", fontWeight: "700" }}>{"Failed"}({item.failureQuantity})</span> : ""}{" "}{item.vendRemaining ? <span style={{ color: "#F28618", fontSize: "10px", fontFamily: "roboto", fontWeight: "700" }}>{"Pending"}({item.vendRemaining})</span> : ""}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>



              </Stack>
            </CardContent>
          </Card>
          <Card  style={{boxShadow:"none"}}sx={{ mx: 2, mb: 2, background: "#EEF6F3",boxShadow:"none" }} >
            <CardContent>
              <Typography variant="subtitle1" fontWeight="bold" fontSize={14} color="#898C8E">
                Paid Amount :<span style={{ color: "#343A40" }}> ₹{" "}{props && props.orderReport && props.orderReport.data.refundDetailInfoList[0].paidAmount}</span>
              </Typography>


              <Divider sx={{ my: 1 }} />
              <Typography variant="body2" style={{fontSize:"14px",color:"#000000B2",fontSize:"12px"}}>{formatpaymentTime}</Typography>
              <Typography variant="body2" sx={{ wordBreak: 'break-word' }}>
                <span style={{fontSize:"12px",color:"#000000B2",fontWeight:"400"}}>Transaction ID: {props && props.orderReport && props.orderReport.data.refundDetailInfoList[0].transactionId}</span>
              </Typography>
              <Typography variant="body2" sx={{ wordBreak: 'break-word' }}>
                <span style={{fontSize:"12px",color:"#000000B2",fontWeight:"400"}}>Payment Method :  {props && props.orderReport && props.orderReport.data.refundDetailInfoList[0].pgName}</span>
              </Typography>
            </CardContent>
          </Card>


          <Card style={{boxShadow:"none",marginTop:"5vw",marginBottom:isWebview?"150px":"110px"}} sx={{ display: "flex", justifyContent: "space-around", alignItems: "center", mx: 2, mb: 2, textAlign: 'center',  background: "#EEF6F3", }}>

            {/* Illustration Placeholder */}
            <Box sx={{}}>
              <Box
                component="img"
                src={Searching}
                alt="Uploaded or placeholder"
                sx={{ maxWidth: '100%', maxHeight: 130, borderRadius: 2 }}
              />
            </Box>
            <Box>
              <Typography variant="body1" color={"#000000"} fontWeight={400} fontSize={16} fontFamily={"Roboto"}>Have Any Concerns?</Typography>
              <Button
                onClick={(e) => HandleRaiseTicket(e,props,mobileNumber)}
                variant="outlined"
                 style={{fontWeight:700,fontSize:"16px"}}
                sx={{
                  mt: 1,
                  height: "40px",
                  padding: "20px",
                  border: "2px solid #0AA36D",
                  background: "white",
                  color: "#0AA36D",
                    textTransform: 'none',
                  "&:hover": {
                    //background: "#E6F4F1", // Light green background on hover
                    //borderColor: "#0AA36D",
                  }
                }}
              >
                Raise A Ticket
              </Button>



            </Box>
          </Card>
        </>
        }

   


   {  props && props.orderReport && props.orderReport.data.refundDetailInfoList[0].status === "REFUND_INITIATION_FAILED"&& 
   <><Box sx={{ p: 2 }}> 
      <>
              <Box sx={{ textAlign: 'left', mb: 2 ,mt:8 }} display={"flex"} alignItems={"center"} justifyContent={"space-between"}>
              <div>
                <Typography variant="body2" sx={{ color: '#583C43', fontSize: "16px", fontWeight: "500" }}>
                  Order_{props && props.orderReport && props.orderReport.data.orderId}
                </Typography>
                <Typography variant="body2" sx={{ color: "#583C43", fontSize: "16px", fontWeight: "400" }}>{props && props.orderReport && props.orderReport.data.refundDetailInfoList[0].paymentTime ? formatpaymentTime : "Not Availabel"}</Typography>
              </div>
       {
  (platform==checkDevice&&browser==currentbrowser) ? null : (
    <div>
       {/*  {console.log("isWebview condition for share btn",isWebview,!(isWebview=="true"))} */}
      {!(isWebview=="true")&&
      <img
        onClick={(e) => handleShareReceiptImg(e)}
        src={shareImg}
        style={{ width: "24px" }}
      />}
    </div>
  )
}
            </Box>
            <div style={{ marginTop: "10vw" }}>
              <Box sx={{ display: "flex", justifyContent: "center" }}>
                <Box
                  component="img"
                  src={refundfailed}
                  alt="RefundeInitfailed"
                  sx={{ maxHeight: 155, borderRadius: 2, width: "68px", height: "68px" }}
                />
              </Box>


              <h1
                style={{
                  color: "#C20C0C",
                  fontSize: "20px",
                  fontWeight: "600",
                  textAlign: "center",
                  marginTop: "2vw",
                }}
              >
                 Refund Initiation Failed
              </h1>
              <div className="refund-box">
                <p style={{fontWeight:400,fontSize:"12px",fontFamily:"Poppins"}}>
                  We Encountered An Issue While Processing Your Refund.
                </p>
              </div>
            </div>

            <div className=" rounded-lg p-3 mb-4" style={{background:"#EEF6F3"}}>
              <p className="text-gray-800 font-semibold" style={{fontSize:"14px"}}><span style={{ color: "#898C8E" }}>Amount To Be Refunded :</span>  ₹ {props && props?.orderReport?.data?.refundDetailInfoList[0]?.refundAmount}</p>
              <hr style={{ marginTop: "1vw", marginBottom: "2vw" }} />
              <p className="text-xs text-gray-600 mt-1" style={{fontSize:"12px"}}>Expected Settlement Time: After Initiation  </p>

            </div>


            <div className="bg-gray-100 rounded-lg p-3 mb-4" style={{background: "#EEF6F3",}}>
              <p className="text-gray-800 font-semibold" style={{fontSize:"14px"}}><span style={{ color: "#898C8E" }}>Order : </span>1 Items</p>
              <hr style={{ marginTop: "1vw", marginBottom: "2vw" }} />
              <div className="grid grid-cols-3 text-center mt-2 font-medium text-gray-600 text-xs  border-gray-300 pb-1" style={{fontSize:"12px"}}>
                <div>Item(Count)</div>
                <div>Price/Unit</div>
                <div>Status</div>
              </div>
              {props && props.orderReport.data.orderLineItem.map((item, index) => (

                <div   key={ index} className="grid grid-cols-3 text-center text-sm mt-1 text-gray-800" style={{ fontSize: "10px" }}>
                  <div>                          {item.variantName.length > 8 ? item.variantName.slice(0, 20) + '...' : item.variantName} ({String(item.itemQuantity).padStart(2, '0')})
                  </div>
                  <div>₹  {item.amount}</div>
                  <div className="text-red-500 font-medium">                          {item.successQuantity ? <span style={{ color: "#000000B2", fontSize: "10px", fontFamily: "roboto", fontWeight: "700" }}>{"Success"}({item.successQuantity})</span> : ""}{" "}{item.failureQuantity > 0 ? <span style={{ color: "#E65C5C", fontSize: "10px", fontFamily: "roboto", fontWeight: "700" }}>{"Failed"}({item.failureQuantity})</span> : ""}{" "}{item.vendRemaining > 0 ? <span style={{ color: "#F28618", fontSize: "10px", fontFamily: "roboto", fontWeight: "700" }}>{"Pending"}({item.vendRemaining})</span> : ""}
                  </div>
                </div>

              ))}
            </div>

            <div className="bg-gray-100 rounded-lg p-3" style={{background: "#EEF6F3",}}>
              <p className="text-gray-800 font-semibold" style={{fontSize:"14px"}}><span style={{ color: "#898C8E" }}>Paid Amount : </span> ₹ {props?.orderReport?.data?.refundDetailInfoList[0]?.paidAmount}</p>
              <hr style={{ marginTop: "1vw", marginBottom: "2vw" }} />
              <p className="text-xs text-gray-600 mt-1" style={{fontSize:"12px",color:"#000000B2",fontWeight:"400"}}>{formatpaymentTime}</p>
              <p className="text-xs text-gray-600" style={{fontSize:"12px",color:"#000000B2",fontWeight:"400",marginTop: "8px"}}>Transaction ID: {props?.orderReport?.data?.refundDetailInfoList[0]?.transactionId}</p>
                            <p className="text-xs text-gray-600" style={{fontSize:"12px",color:"#000000B2",fontWeight:"400",marginTop: "8px"}}> Payment Method: {props && props.orderReport && props.orderReport.data.refundDetailInfoList[0].pgName}</p>

            </div>
          </>
   
   <Card style={{boxShadow:"none",marginTop:"5vw",marginBottom:isWebview?"150px":"110px"}} sx={{ display: "flex", justifyContent: "space-around", alignItems: "center", textAlign: 'center', background: "#EEF6F3", }} >

            {/* Illustration Placeholder */}
            <Box >
              <Box
                component="img"
                src={Searching}
                alt="Uploaded or placeholder"
                sx={{ maxWidth: '100%', maxHeight: 130, borderRadius: 2 }}
              />
            </Box>
            <Box>
              <Typography variant="body1" color={"#000000"} fontWeight={600} fontSize={14} fontFamily={"Roboto"}>Please Raise Ticket Here</Typography>
              <Button
                onClick={(e) => HandleRaiseTicket(e,props,mobileNumber)}
                variant="outlined"
                 style={{fontWeight:700,fontSize:"16px"}}
                sx={{
                  mt: 1,
                  height: "40px",
                  padding: "20px",
                  border: "2px solid #0AA36D",
                  background: "#0AA36D",
                  textTransform:"none",
                  color: "white",
                  "&:hover": {
                    //background: "#E6F4F1", // Light green background on hover
                    //borderColor: "#0AA36D",
                  }
                }}
              >
                Raise A Ticket
              </Button>



            </Box>
          </Card>
          </Box>
          </>}


             {  props && props.orderReport && props.orderReport.data.refundDetailInfoList[0].status === "REFUND_FAILED"&& 
   <><Box sx={{ p: 2 }}> 
      <>
              <Box sx={{ textAlign: 'left', mb: 2 ,mt:8}} display={"flex"} alignItems={"center"} justifyContent={"space-between"}>
              <div>
                <Typography variant="body2" sx={{ color: '#583C43', fontSize: "16px", fontWeight: "500" }}>
                  Order_{props && props.orderReport && props.orderReport.data.orderId}
                </Typography>
                <Typography variant="body2" sx={{ color: "#583C43", fontSize: "16px", fontWeight: "400" }}>{props && props.orderReport && props.orderReport.data.refundDetailInfoList[0].paymentTime ? formatpaymentTime : "Not Availabel"}</Typography>
              </div>
       {
  (platform==checkDevice&&browser==currentbrowser) ? null : (
    <div>
        {/* {console.log("isWebview condition for share btn",isWebview,!(isWebview=="true"))} */}
      {!(isWebview=="true")&&
      <img
        onClick={(e) => handleShareReceiptImg(e)}
        src={shareImg}
        style={{ width: "24px" }}
      />}
    </div>
  )
}
            </Box>
            <div style={{ marginTop: "10vw" }}>
              <Box sx={{ display: "flex", justifyContent: "center" }}>
                <Box
                  component="img"
                  src={RefundeInitfailed}
                  alt="RefundeInitfailed"
                  sx={{ maxHeight: 155, borderRadius: 2, width: "68px", height: "68px" }}
                />
              </Box>


              <h1
                style={{
                  color: "#C20C0C",
                  fontSize: "20px",
                  fontWeight: "600",
                  textAlign: "center",
                  marginTop: "2vw",
                }}
              >
                 Refund  Failed
              </h1>
              <div className="refund-box">
                <p style={{fontWeight:400,fontSize:"12px",fontFamily:"Poppins"}}>
                  Refund Could Not Be Processed Due To A Technical Issue, Failure Reference Number Is {props?.orderReport?.data?.refundDetailInfoList[0]?.transactionId}
                </p>
              </div>
            </div>

            <div className=" rounded-lg p-3 mb-4" style={{background:"#EEF6F3"}}>
              <p className="text-gray-800 font-semibold" style={{fontSize:"14px"}}><span style={{ color: "#898C8E" }}>Amount To Be Refunded :</span>  ₹ {props && props?.orderReport?.data?.refundDetailInfoList[0]?.refundAmount}</p>
              <hr style={{ marginTop: "1vw", marginBottom: "2vw" }} />
              <p className="text-xs text-gray-600 mt-1">Expected Settlement Time: Refund processing (refund schedule time + 60 minutes)</p>

            </div>


            <div className="bg-gray-100 rounded-lg p-3 mb-4" style={{background:"#EEF6F3"}}>
              <p className="text-gray-800 font-semibold" style={{fontSize:"14px"}}><span style={{ color: "#898C8E" }}>Order : </span>1 Items</p>
              <hr style={{ marginTop: "1vw", marginBottom: "2vw" }} />
              <div className="grid grid-cols-3 text-center mt-2 font-medium text-gray-600 text-xs  border-gray-300 pb-1">
                <div style={{textAlign:"start"}}>Item(Count)</div>
                <div>Price/Unit</div>
                <div style={{    marginRight: "2vw"}}>Status</div>
              </div>
              {props && props.orderReport.data.orderLineItem.map((item, index) => (

                <div   key={index} className="grid grid-cols-3 text-center text-sm mt-1 text-gray-800" style={{ fontSize: "10px" }}>
                  <div style={{textAlign:"start"}}>                          {item.variantName.length > 8 ? item.variantName.slice(0, 20) + '...' : item.variantName} ({String(item.itemQuantity).padStart(2, '0')})
                  </div>
                  <div>₹  {item.amount}</div>
                  <div className="text-red-500 font-medium">                          {item.successQuantity ? <span style={{ color: "#000000B2", fontSize: "12px", fontFamily: "roboto", fontWeight: "700" }}>{"Success"}({item.successQuantity})</span> : ""}{" "}{item.failureQuantity > 0 ? <span style={{ color: "#E65C5C", fontSize: "12px", fontFamily: "roboto", fontWeight: "700" }}>{"Failed"}({item.failureQuantity})</span> : ""}{" "}{item.vendRemaining > 0 ? <span style={{ color: "#F28618", fontSize: "12px", fontFamily: "roboto", fontWeight: "700" }}>{"Pending"}({item.vendRemaining})</span> : ""}
                  </div>
                </div>

              ))}
            </div>

            <div className="bg-gray-100 rounded-lg p-3" style={{background:"#EEF6F3"}}>
              <p className="text-gray-800 font-semibold" style={{fontSize:"14px"}}><span style={{ color: "#898C8E" }}>Paid Amount : </span> ₹ {props?.orderReport?.data?.refundDetailInfoList[0]?.paidAmount}</p>
              <hr style={{ marginTop: "1vw", marginBottom: "2vw" }} />
              <p className="text-xs text-gray-600 mt-1"style={{fontSize:"12px",color:"#000000B2",fontWeight:"400"}}>{formatpaymentTime}</p>
              <p className="text-xs text-gray-600" style={{fontSize:"12px",color:"#000000B2",fontWeight:"400"}}>Transaction ID: {props?.orderReport?.data?.refundDetailInfoList[0]?.transactionId}</p>
              <p className="text-xs text-gray-600 mt-2" >Payment Method : <span className="font-medium"> {props?.orderReport?.data?.refundDetailInfoList[0]?.payMethod}</span></p>
            </div>
          </>
   
   <Card style={{boxShadow:"none",marginTop:"5vw"}} sx={{ display: "flex", justifyContent: "space-around", alignItems: "center", textAlign: 'center', background: "#EEF6F3",marginBottom:isWebview?"150px":"110px" }} >

            {/* Illustration Placeholder */}
            <Box sx={{ }}>
              <Box
                component="img"
                src={Searching}
                alt="Uploaded or placeholder"
                sx={{ maxWidth: '100%', maxHeight: 130, borderRadius: 2 }}
              />
            </Box>
            <Box>
              <Typography variant="body1" color={"#000000"} fontWeight={600} fontSize={14} fontFamily={"Roboto"}>Please Raise Ticket Here</Typography>
              <Button
                onClick={(e) => HandleRaiseTicket(e,props,mobileNumber)}
                variant="outlined"
                 style={{fontWeight:700,fontSize:"16px"}}
                sx={{
                  mt: 1,
                  height: "40px",
                  padding: "20px",
                  border: "2px solid #0AA36D",
                  background: "#0AA36D",
                  color: "white",
                  textTransform:"none",
                  "&:hover": {
                    //background: "#E6F4F1", // Light green background on hover
                    //borderColor: "#0AA36D",
                  }
                }}
              >
                Raise A Ticket
              </Button>



            </Box>
          </Card>
          </Box>
          </>}
   
      </Box>
    </>
  );
}
